module.exports = __webpack_public_path__ + "static/img/pay-2.61128dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay/pay-2.png
// module id = pwRT
// module chunks = 1